module.exports = __webpack_public_path__ + "static/media/Jungle Explorer.463aff93.jpg";